import * as React from "react";
import { Store } from "redux";
import LinkfluenceApp from "@linkfluence/core/app";
import Authenticated from "@linkfluence/core/auth/router";
import createStore from "@linkfluence/core/store";
import { App } from "@linkfluence/models/app";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import Loading from "@ui-kit/splash-screen";
import UserConnectedPage from "@radarly/core/bootstrap/user";

interface IProps {
  children: React.ReactNode;
  store?: Store<any>;
  refresher?: any;
}

const radarlyStore = createStore();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      useErrorBoundary: undefined,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      suspense: false,
    },
  },
});

const RadarlyCoreApp = ({ store, refresher, children }: IProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <LinkfluenceApp
        store={store || radarlyStore}
        client={App.Radarly}
        refresher={refresher}
        loader={<Loading />}
      >
        <Authenticated Component={UserConnectedPage} client={App.Radarly}>
          {children}
        </Authenticated>
      </LinkfluenceApp>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default RadarlyCoreApp;
